import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-542b12bc")

_pushScopeId("data-v-542b12bc")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Hoe oud bent u? ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Met de slider kunt u uw leeftijd instellen. Bent u ouder dan 64 jaar en bent u ziek geworden? Dan komt u niet meer in aanmerking voor een uitkering van NV schade. De eerste 104 weken na uw ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("eerste ziektedag")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" betaalt uw werkgever uw loon (gedeeltelijk) door. Pas na deze 104 weken komt u eventueel in aanmerking voor een uitkering. Omdat u tijdens deze 104 weken de ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("AOW-leeftijd")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" bereikt, heeft u geen recht meer op een uitkering uit de verzekeringen van NV schade. ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NVAbbr = _resolveComponent("NVAbbr")
  const _component_Explain = _resolveComponent("Explain")
  const _component_Slider = _resolveComponent("Slider")
  const _component_Step = _resolveComponent("Step")

  return (_openBlock(), _createBlock(_component_Step, { step: _ctx.step }, {
    header: _withId(() => [
      _createVNode("h2", null, [
        _hoisted_1,
        _createVNode(_component_Explain, { title: "Wat is uw leeftijd?" }, {
          default: _withId(() => [
            _hoisted_2,
            _createVNode(_component_NVAbbr, null, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _hoisted_4,
            _createVNode(_component_NVAbbr, null, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", {
        class: "value",
        textContent: _toDisplayString(_ctx.state.age)
      }, null, 8, ["textContent"]),
      _createVNode(_component_Slider, {
        modelValue: _ctx.state.age,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.state.age = $event)),
        max: 65,
        min: 16,
        "label-left": "Min. 16 jaar",
        "label-right": "Max. 65 jaar"
      }, null, 8, ["modelValue"]),
      (_ctx.state.age <= 23)
        ? (_openBlock(), _createBlock("p", _hoisted_7, " Verdient u op basis van jeugdloon? Dan berekent het UWV bij arbeidsongeschiktheid uw wettelijke uitkering op een andere manier. In deze calculator is hier geen rekening mee gehouden. De berekening die u ziet kan dus afwijken van uw situatie. "))
        : (_ctx.state.age >= 64)
          ? (_openBlock(), _createBlock("p", _hoisted_8, " Als u op of na uw 65e verjaardag ziek wordt, komt u niet in aanmerking voor een WIA-uitkering. De eerste twee ziektejaren betaalt uw werkgever uw loon door. Na uw 67e verjaardag ontvangt u een AOW-uitkering. "))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["step"]))
})